import WalledContent from 'components/Common/WalledContent'
import React from 'react'

import { accountAccessShowLogin } from 'actions/UiActions'
import TextLink from 'components/Luxkit/TextLink'
import { useAppDispatch } from 'hooks/reduxHooks'
import LEOfferPriceDetails from './LEOfferPriceDetails'

interface Props {
  offer: App.Offer | App.OfferSummary
}

interface MappedProps {
}

const LEOfferPriceDetailsWrapper = ({ offer }: Props & MappedProps) => {
  const dispatch = useAppDispatch()

  const pkg = offer.lowestPricePackage
  if (!pkg) {
    return null
  }

  const wall = (
    <TextLink
      onClick={(e) => {
        e.preventDefault()
        dispatch(accountAccessShowLogin())
      }}
    >
      Become a member to see rates
    </TextLink>
  )

  return (
    <WalledContent enforced={offer.walledGarden} wall={wall}>
      <LEOfferPriceDetails offer={offer} pkg={pkg} />
    </WalledContent>
  )
}

export default LEOfferPriceDetailsWrapper
